import * as React from 'react';
import './NavLinkList.css';
import { NavButton } from '../nav-link/NavLink';
import { Col, Container, Row, Nav } from 'reactstrap';

type navLinkListProps = {
  type: 'nav'|'hero'
}

export class NavLinkList extends React.Component<navLinkListProps, {}> {

  private readonly navLinkData = [
    { value: "Mitä me teemme",  path:"about",     desc: "Hyvien kokemuksien anatomia"     },
    { value: "Työt",            path:"portfolio", desc: "Tutustu tekemiimme projekteihin" },
    { value: "Asiakkaat",       path:"clients",   desc: "Keiden kanssa työskentelemme"    },
    { value: "Ota yhteyttä",    path:"contact",   desc: "Kerromme mielemmämme lisää"      }
  ];


  render() {
    switch (this.props.type) {
      case 'nav':
        return (
          <Nav className="ml-auto" navbar>
            {
              this.navLinkData.map( (data, index) => {
                return (
                  <NavButton key={index} value={data.value} path={data.path} desc={data.desc} type={this.props.type} />
                );
              })
            }
          </Nav>
        );
      case 'hero':
        return (
          <Container className="p-0">
            <Row noGutters>
              {
                this.navLinkData.map( (data, index) => {
                  return (
                    <Col xs="12" sm="12" md="3" key={index} className="nav-button-container" >
                      <NavButton value={data.value} path={data.path} desc={data.desc} type={this.props.type} index={index} />
                    </Col>
                  );
                })
              }
            </Row>
          </Container>
        );
      default:
        return null;
    }

  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/nav-link-list/NavLinkList.tsx